import { ExtendedCategory } from '@wix/answers-api';
import { helpcenterApi } from '../../../api';
import { RecoverableError } from '../../../common/errors/recoverable-error';
import { deepSearch } from '../../../common/utils';
import { MAX_LIMIT_CATEGORY_ARTICLES } from './common/loaders-defaults-data';
import { ClientSafeTenant } from '../../../helpcenter-data';
import { ArticleMatch } from '../routes';

export const loadArticleData = async (
  params: ArticleMatch,
  initialData: any,
  baseUrl?: string,
) => {
  const article = await helpcenterApi.getArticleByUri(
    params.articleUri,
    {
      params: { locale: params.locale },
    },
    baseUrl,
  );

  if (article.uri !== `/article/${params.articleUri}`) {
    throw new RecoverableError(
      'article redirect',
      'REDIRECT',
      `${article.uri}`,
    );
  }
  const relatedArticles = await helpcenterApi.getArticleRelationsById(
    article.id,
    {
      params: { locale: params.locale },
    },
    baseUrl,
  );
  const categoryTree = await initialData.helpcenter.categoryTree;
  const parentCategory: ExtendedCategory = deepSearch<any, any>(
    categoryTree,
    'children',
    (item) => item.id === article.categoryId,
  );
  const limit = parentCategory.publishedArticleCount <= MAX_LIMIT_CATEGORY_ARTICLES ? parentCategory.publishedArticleCount : MAX_LIMIT_CATEGORY_ARTICLES;
  const parentCategoryArticles = await helpcenterApi.getCategoryTopArticles(
    {
      locale: params.locale,
      categoryIds: [article.categoryId],
      limit
    },
    baseUrl,
  );

  return {
    article,
    relatedArticles,
    parentCategoryArticles,
  };
};

const loadDataClient = (params: ArticleMatch, tenant?: ClientSafeTenant, location?: any, initialData?: any): Promise<any> =>
  Promise.all([loadArticleData(params, initialData)]);

export default loadDataClient;
